import React from 'react'
import './assets/App.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ReactDOM from "react-dom/client";
import Home from './components/Home';
import Categories from './components/Categories';
import Panier from './components/Panier';
import SuivreMaCommande from './components/SuivreMaCommande';
import Blog from './components/Blog';
import ProgrammeDeFidelite from './components/ProgrammeDeFidelite';
import Produit from './components/Produit';
import MonCompte from './components/MonCompte';
import CreationCompte from './components/CreationCompte';

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
      errorElement: <Home />,
      exact: true
    },
    {
      path: "/categories/:id",
      element: <Categories />,
      exact: true
    },
    {
      path: "/panier",
      element: <Panier />,
      exact: true

    },
    {
      path: "/suivre-ma-commande",
      element: <SuivreMaCommande />,
      exact: true

    },
    {
      path: "/mon-compte",
      element: <MonCompte />,
      exact: true

    },
    {
      path: "/creation-compte",
      element: <CreationCompte />,
      exact: true

    },
    {
      path: "/programme-de-fidelite",
      element: <ProgrammeDeFidelite />,
      exact: true

    },
    {
      path: "/blog",
      element: <Blog />,
      exact: true

    },
    {
      path: "/produit/:id",
      element: <Produit />,
      exact: true

    },
  ]);

  return (
    <RouterProvider router={router} />
  )
}

export default App